import {
	Directive,
	EventEmitter,
	HostListener,
	OnDestroy,
	OnInit,
	Output,
} from '@angular/core';
import { Subject, Subscription } from 'rxjs';
import { debounceTime } from 'rxjs/operators';

@Directive({
	selector: '[cmvDebounceClick]',
})
export class DebounceClickDirective implements OnInit, OnDestroy {
	@Output() cmvDebounceClick = new EventEmitter();
	debounceTime = 200;
	private clicks = new Subject();
	private subscription!: Subscription;

	constructor() {}

	ngOnInit(): void {
		this.subscription = this.clicks
			.pipe(debounceTime(this.debounceTime))
			.subscribe(event => {
				this.cmvDebounceClick.emit(event);
			});
	}

	ngOnDestroy(): void {
		this.subscription.unsubscribe();
	}

	@HostListener('click', ['$event'])
	clickEvent(event: Event) {
		event.preventDefault();
		event.stopPropagation();
		this.clicks.next(event);
	}
}
